// === TYPOGRAPHIE CENTRALISÉE ===
// Polices et helpers de style texte pour tout le jeu.
// Le pixel art ambiance vient des sprites SVG ; les textes utilisent
// une sans-serif système plus lisible (surtout sur mobile).

import Phaser from 'phaser';

/**
 * Police principale : sans-serif système, optimisée lisibilité écran.
 * Utilisée pour 99% des textes (titres, descriptions, dialogues, menus).
 */
export const FONT_BODY = '"Segoe UI", Roboto, "Helvetica Neue", Arial, system-ui, sans-serif';

/**
 * Police monospace propre : pour stats, valeurs numériques, blocs "code".
 * Utilisée ponctuellement quand l'alignement vertical compte.
 */
export const FONT_MONO = 'Consolas, "Lucida Console", "Courier New", monospace';

/**
 * Police de titre : actuellement la même que body (on joue sur fontStyle: bold).
 * Centralisée pour pouvoir basculer sur une display font plus tard si besoin.
 */
export const FONT_TITLE = '"Segoe UI", Roboto, "Helvetica Neue", Arial, system-ui, sans-serif';

/**
 * Ombre de texte par défaut : assure la lisibilité sur fond varié
 * (combat, exploration, événements). Subtile mais efficace.
 */
export const DEFAULT_TEXT_SHADOW = {
  offsetX: 1,
  offsetY: 1,
  color: '#000000',
  blur: 2,
  fill: true,
  stroke: false,
} as const;

/**
 * Ombre de texte renforcée pour texte clair sur fond clair (HP, dégâts en combat).
 */
export const STRONG_TEXT_SHADOW = {
  offsetX: 1,
  offsetY: 1,
  color: '#000000',
  blur: 3,
  fill: true,
  stroke: true,
} as const;

/**
 * Applique une ombre par défaut à un objet texte Phaser après création.
 * Pratique pour les textes qui passent par-dessus la grille / sprites.
 */
export function applyTextShadow(text: Phaser.GameObjects.Text): Phaser.GameObjects.Text {
  text.setShadow(
    DEFAULT_TEXT_SHADOW.offsetX,
    DEFAULT_TEXT_SHADOW.offsetY,
    DEFAULT_TEXT_SHADOW.color,
    DEFAULT_TEXT_SHADOW.blur,
    DEFAULT_TEXT_SHADOW.fill,
    DEFAULT_TEXT_SHADOW.stroke,
  );
  return text;
}

/**
 * Applique l'ombre forte (texte qui flotte sur fond varié).
 */
export function applyStrongShadow(text: Phaser.GameObjects.Text): Phaser.GameObjects.Text {
  text.setShadow(
    STRONG_TEXT_SHADOW.offsetX,
    STRONG_TEXT_SHADOW.offsetY,
    STRONG_TEXT_SHADOW.color,
    STRONG_TEXT_SHADOW.blur,
    STRONG_TEXT_SHADOW.fill,
    STRONG_TEXT_SHADOW.stroke,
  );
  return text;
}
